import { UnknownVerifiableCredential } from '../credential/verifiable/unknown';
import { ApiClient, PresentationDescriptor, VerificationResult } from '../types';
import { generateKey } from '../utils/idempotency';

export class VerifiablePresentation {
    constructor(
        private client: ApiClient,
        public descriptor: PresentationDescriptor,
    ) {}

    async getCredentials(): Promise<UnknownVerifiableCredential[]> {
        const credentialResources = await Promise.all(
            this.descriptor.data.linkedCredentials.map((credentialId) =>
                this.client.credentials.credentialLatest(credentialId),
            ),
        );

        return credentialResources.map(
            (credentialResource) => new UnknownVerifiableCredential(this.client, credentialResource),
        );
    }

    async verify(): Promise<VerificationResult> {
        const result = await this.client.presentations.presentationVerify(this.descriptor.id);

        return {
            verified: result.verified || false,
        };
    }

    async send(targetId: string, privateKeyId: string): Promise<void> {
        await this.client.didcommMessages.didCommMessageSend({
            data: {
                to: targetId,
                keyId: privateKeyId,
                presentations: [this.descriptor.id],
            },
            idempotencyKey: generateKey('send'),
        });
    }
}
